import { dateFormat, formatDate } from 'helpers/AppHelpers';
import moment from 'moment';

const ACTIONS = {
  SKIP: 'SKIP',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
};

const getEventName = (fullName, employmentName) => `${fullName} - ${employmentName}`;

const createEventFromEmployment = ({ fullName, day, employmentName }) => ({
  subject: getEventName(fullName, employmentName),
  start: {
    dateTime: moment(day).format(dateFormat),
    timeZone: 'Pacific Standard Time'
  },
  end: {
    dateTime: moment(day).add(1, 'd').format(dateFormat),
    timeZone: 'Pacific Standard Time'
  },
  isAllDay: true,
  isReminderOn: false,
  showAs: 'free'
});

const isSameDayEvent = (startDateTime, localEventDate) =>
  formatDate(startDateTime) === formatDate(localEventDate);

const determineActions = (localEvents, msCalendarEvents) => {
  return localEvents
    .map((localEvent) => {
      const msEvent = msCalendarEvents.find(
        ({ start, subject }) =>
          isSameDayEvent(start.dateTime, localEvent.day) && subject.includes(localEvent.fullName)
      );

      if (!msEvent && !localEvent.employmentName) {
        return { action: ACTIONS.SKIP };
      }

      if (!msEvent && localEvent.employmentName) {
        return {
          action: ACTIONS.CREATE,
          event: createEventFromEmployment(localEvent)
        };
      }

      if (msEvent && !localEvent.employmentName) {
        return { action: ACTIONS.DELETE, eventId: msEvent.id };
      }

      if (
        msEvent &&
        localEvent.employmentName &&
        getEventName(localEvent.fullName, localEvent.employmentName) !== msEvent.subject
      ) {
        return {
          action: ACTIONS.UPDATE,
          event: createEventFromEmployment(localEvent),
          eventId: msEvent.id
        };
      }

      return { action: ACTIONS.SKIP };
    })
    .filter(({ action }) => action !== ACTIONS.SKIP);
};

const createBatchRequests = (calendarId, actions) => {
  return actions.map((event, index) => {
    let method;
    let url;
    let body;

    switch (event.action) {
      case ACTIONS.CREATE:
        method = 'POST';
        url = `me/calendars/${calendarId}/events`;
        body = event.event;
        break;
      case ACTIONS.UPDATE:
        method = 'PATCH';
        url = `me/calendars/${calendarId}/events/${event.eventId}`;
        body = event.event;
        break;
      case ACTIONS.DELETE:
        method = 'DELETE';
        url = `me/calendars/${calendarId}/events/${event.eventId}`;
        body = null;
        break;
      default:
        break;
    }

    return {
      id: `event${index}`,
      method,
      url,
      headers: { 'Content-Type': 'application/json' },
      body
    };
  });
};

export { determineActions, createBatchRequests };
